import { render } from "./CoBrandHearthside.vue?vue&type=template&id=582bca9c&scoped=true"
import script from "./CoBrandHearthside.vue?vue&type=script&lang=js"
export * from "./CoBrandHearthside.vue?vue&type=script&lang=js"

import "./CoBrandHearthside.vue?vue&type=style&index=0&id=582bca9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-582bca9c"]])

export default __exports__